<template>
  <div v-if="locationName === '' || locationName == null || false">
    <div class="row">
      <div class="col-12">
        <h5>Dieser Kunde hat keinen Standort.</h5>
        <p>Sie müssen den Standort auswählen, wenn Sie Maßnahmen hinzufügen oder ändern möchten</p>
      </div>
    </div>
  </div>
  <div v-else>

    <form v-if="isLoaded" @submit.prevent="submitPrivateCoachingForm" novalidate
          location-id=""
          location-name=""
          private-coaching-id=""
          unemployed-id=""
          submit-form>
      <div class="row">
        <div class="col-12">
          <h6 class="mb-4">Standort: {{ locationName }}</h6>

          <AuditInfo
              :user-role="currentUserRole"
              :created-by-user-data="formData.createdByUserData"
              :created-at="formData.createdAt"
              :updated-by-user-data="formData.updatedByUserData"
              :updated-at="formData.updatedAt"/>

          <!--      {{vPrivateCoaching$.$errors }}-->
          <div v-if="
              formData.unemployedId === '' ||
              formData.unemployedId == null ||
               false">
            <h6 class="mb-4" style="color: red">{{ $t('general.error') }}</h6>
          </div>
        </div>

        <div class="col-lg-8 col-md-12 col-sm-12">
          <div class="row">
            <div class="col-lg-8 col-md-12 col-sm-12">
              <SelectVue
                  v-model="formData.courseId"
                  :options="courseDropdown"
                  :required="true"
                  label="Bezeichnung"
                  placeholder="Leistungsart auswählen"
                  :validation="vPrivateCoaching$.courseId"
                  :messages="vPrivateCoaching$.courseId.required.$message"
                  @update:modelValue="onChangeCourseId"/>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12">
              <BaseInput
                  v-model="courseActionNumber"
                  label="Maßnahmennummer"
                  :disabled="true"/>
            </div>
          </div>

          <SelectVue
              v-model="formData.clientId"
              :options="clientDropdown"
              :required="true"
              label="Kostenträger"
              placeholder="Wählen Sie Kostenträger"
              :validation="vPrivateCoaching$.clientId"
              :messages="vPrivateCoaching$.clientId.required.$message"/>

          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <Datepicker
                      v-model="formData.startDate"
                      :required="true"
                      label="Start"
                      position="down"
                      :validation="vPrivateCoaching$.startDate"
                      :messages="vPrivateCoaching$.startDate.required.$message"/>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                  <Datepicker
                      v-model="formData.endDate"
                      :required="true"
                      label="Ende"
                      position="down"
                      :validation="vPrivateCoaching$.endDate"
                      :messages="vPrivateCoaching$.endDate.required.$message"/>
                </div>
              </div>

              <SelectVue
                  v-model="formData.coach1Id"
                  :options="coach1Dropdown"
                  :required="true"
                  label="Coach 1"
                  placeholder="Wählen Sie Coach"
                  :validation="vPrivateCoaching$.coach1Id"
                  :messages="vPrivateCoaching$.coach1Id.required.$message"/>

              <SelectVue
                  v-model="formData.coach3Id"
                  :options="coach3Dropdown"
                  :is-clear="true"
                  label="Coach 3"
                  placeholder="Wählen Sie Coach"/>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <BaseInput
                  v-model="formData.clerk"
                  label="Sachbearbeiter"/>

              <SelectVue
                  v-model="formData.coach2Id"
                  :options="coach2Dropdown"
                  :is-clear="true"
                  label="Coach 2"
                  placeholder="Wählen Sie Coach"/>

              <SelectVue
                  v-model="formData.coach4Id"
                  :options="coach4Dropdown"
                  :is-clear="true"
                  label="Coach 4"
                  placeholder="Wählen Sie Coach"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12">
              <SelectVue
                  v-model="formData.billingType"
                  :options="billingTypeDropdown"
                  :required="true"
                  label="Art der Abrechnung"
                  placeholder="Wählen Sie Art der Abrechnung"
                  :validation="vPrivateCoaching$.billingType"
                  :messages="vPrivateCoaching$.billingType.required.$message"/>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <SelectVue
                  v-model="formData.digitalDocumentsUuid"
                  :options="digitalDocumentsDropdown"
                  :required="false"
                  :is-clear="true"
                  label="Digitale Dokumente"
                  placeholder="Wählen Sie digitale Dokumente aus"/>
            </div>
          </div>

          <!--          <div class="row shadow-sm pt-3 pb-3">-->
          <!--            <div class="col-lg-6 col-md-12 col-sm-12">-->
          <!--              <BaseCheckbox-->
          <!--                  v-model="formData.billingTypeDifferent"-->
          <!--                  :labelPosition="'right'"-->
          <!--                  label="Abrechnungsart abweichend"/>-->
          <!--            </div>-->
          <!--            <div class="col-lg-6 col-md-12 col-sm-12">-->
          <!--              <div v-if="formData.billingTypeDifferent && billingTypeDropdown?.length">-->
          <!--                <SelectVue-->
          <!--                    v-model="formData.billingType"-->
          <!--                    :options="billingTypeDropdown"-->
          <!--                    :required="true"-->
          <!--                    label="Art der Abrechnung"-->
          <!--                    placeholder="Art der Abrechnung"-->
          <!--                    :validation="vPrivateCoaching$.billingType"-->
          <!--                    :messages="vPrivateCoaching$.billingType.required.$message"/>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 text-center">
          <BaseToggle
              v-model="formData.requiresSignature"
              label="Unterschriftspflichtig"/>

          <BaseToggle
              v-model="formData.digitalSignature"
              label="Digitale Unterschrift"/>

          <BaseToggle
              v-model="formData.assumptionOfCosts"
              @change="onAssumptionOfCostsChange"
              label="Fahrtkostenabrechnung"/>

          <div class="row d-flex justify-content-center">
            <BaseRadio
                v-model="formData.arrivalType"
                label="Bus"
                name="arrivalType"
                id="1"
                classFormGroup="col-auto"
                :disabled="isCostsAssumedDisabled"/>
            <BaseRadio
                v-model="formData.arrivalType"
                label="Auto"
                name="arrivalType"
                id="2"
                classFormGroup="col-auto"
                :disabled="isCostsAssumedDisabled"/>
            <BaseRadio
                v-model="formData.arrivalType"
                label="Sonstige"
                name="arrivalType"
                id="3"
                classFormGroup="col-auto"
                :disabled="isCostsAssumedDisabled"/>
          </div>
          <div class="row d-flex justify-content-center">
            <BaseNumber
                v-model="formData.distance"
                label="Summe An- & Abreise in km"
                :disabled="isCostsAssumedDisabled"/>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          AVGS Gültigkeit
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <Datepicker
              v-model="formData.minDateOfFirstMeeting"
              :required="true"
              label="Start"
              :validation="vPrivateCoaching$.minDateOfFirstMeeting"
              :messages="vPrivateCoaching$.minDateOfFirstMeeting.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <Datepicker
              v-model="formData.maxDateOfFirstMeeting"
              :required="true"
              label="Ende"
              :validation="vPrivateCoaching$.maxDateOfFirstMeeting"
              :messages="vPrivateCoaching$.maxDateOfFirstMeeting.required.$message"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div v-if="moduleDropdown && moduleDropdown.length">
            <SelectVue
                v-model="formData.modules"
                :options="moduleDropdown"
                :is-clear="true"
                :is-multi="true"
                :required="true"
                label="Module"
                positionType="top"
                :validation="vPrivateCoaching$.modules"
                :messages="vPrivateCoaching$.modules?.required?.$message"/>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center w-100 mt-3">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import coursePrivateCoachingService from '@/api/Course/PrivateCoaching';
import dropdownService from '@/api/Dropdown';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import AuditInfo from '@/components/AuditInfo.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import BaseToggle from '@/components/base/BaseToggle.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {
  getCoursePrivateCoachingDropdown,
  getPrivateCoachingDigitalDocumentsDropdown,
  getUsersForPrivateCoachingDropdown
} from '@/shared/dropdowns';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const piniaUserState = piniaUserStore();
const currentUserRole = computed(() => piniaUserState.currentUser?.user?.roles?.[0]);
const {t} = useI18n();
const courseDropdown = ref([]);
const clientDropdown = ref([]);
const coach1Dropdown = ref([]);
const coach2Dropdown = ref([]);
const coach3Dropdown = ref([]);
const coach4Dropdown = ref([]);
const digitalDocumentsDropdown = ref([]);
const billingTypeDropdown = ref([]);
const moduleDropdown = ref([]);
const courseActionNumber = ref('');

const isLoaded = ref(false);
const isSubmitting = ref(false);
const isCostsAssumedDisabled = ref(true);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);

const props = defineProps({
  unemployedId: {
    type: Number,
    required: true,
  },
  locationName: {
    type: String,
    required: true,
  },
  locationId: {
    type: Number,
    required: true,
  },
  privateCoachingId: {
    type: Number,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  unemployedId: props.unemployedId, // !!! IMPORTANT
  courseId: null,
  clientId: null,
  coach1Id: null,
  coach2Id: null,
  coach3Id: null,
  coach4Id: null,
  operationType: '',
  clerk: '',
  startDate: '',
  endDate: '',
  billingType: '',
  minDateOfFirstMeeting: '',
  maxDateOfFirstMeeting: '',
  requiresSignature: true,
  digitalSignature: true,
  assumptionOfCosts: false,
  billingTypeDifferent: false,
  arrivalType: '1',
  distance: 0,
  digitalDocumentsUuid: null,
  modules: [],
});

const formRules = ref({
  unemployedId: requiredRule(t),
  courseId: requiredRule(t),
  clientId: requiredRule(t),
  startDate: requiredRule(t),
  endDate: requiredRule(t),
  coach1Id: requiredRule(t),
  billingType: requiredRule(t),
  minDateOfFirstMeeting: requiredRule(t),
  maxDateOfFirstMeeting: requiredRule(t),
  operationType: requiredRule(t),
  modules: '',
});

const computedRules = computed(() => formRules.value);
const vPrivateCoaching$ = useVuelidate(computedRules, formData);

async function submitPrivateCoachingForm() {
  vPrivateCoaching$.value.$touch();
  if (vPrivateCoaching$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    if (props.privateCoachingId) {
      await privateCoachingService.putPrivateCoaching(formData.value, +props.privateCoachingId);
    } else {
      await privateCoachingService.postPrivateCoaching(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function applyPrivateCoachingData(data) {
  try {
    // Add coach/course to dropdown if is logically deleted on backend and is selected for coaching
    addCoachToDropdown(data.data?.coach1, coach1Dropdown);
    addCoachToDropdown(data.data?.coach2, coach2Dropdown);
    addCoachToDropdown(data.data?.coach3, coach3Dropdown);
    addCoachToDropdown(data.data?.coach4, coach4Dropdown);
    addCourseToDropdown(data.data?.nameOfCoaching, courseDropdown);

    const courseId = data.data?.nameOfCoaching.id;
    const clientId = data.data?.client.id;
    const coach1Id = data.data?.coach1?.id;
    const coach2Id = data.data?.coach2?.id;
    const coach3Id = data.data?.coach3?.id;
    const coach4Id = data.data?.coach4?.id;
    const operationType = data?.data?.nameOfCoaching.operationType;
    const arrivalType = String(data.data?.arrivalType);

    // For module - must be this order
    await onChangeCourseId(courseId, false, data.data);
    addClientToDropdown(data.data?.client, clientDropdown);
    const modules = data.data?.modules || [];
    const moduleArray = modules.map(module => module?.id).filter(id => id != null);

    // Check if selected module ids are still in course, if not, filter them out to prevent errors on submit
    const validModuleIds = moduleArray.filter(moduleId =>
        moduleDropdown.value.some(option => option.value === moduleId)
    );

    formData.value = {
      ...data.data,
      unemployedId: props.unemployedId,
      courseId: courseId,
      clientId: clientId,
      coach1Id: coach1Id,
      coach2Id: coach2Id,
      coach3Id: coach3Id,
      coach4Id: coach4Id,
      modules: validModuleIds,
      operationType: operationType,
      arrivalType: arrivalType
    };

  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeCourseId(courseId, onDropdownChange = true, coachingData = null) {
  try {
    const [clientsResult, courseResult] = await Promise.allSettled([
      dropdownService.getCoursePrivateCoachingClients(courseId),
      coursePrivateCoachingService.getCourse(courseId),
    ]);

    if (clientsResult.status === 'fulfilled') {
      clientDropdown.value = clientsResult.value.data.data.map(item => ({
        label: `${item.name}`,
        value: item?.id,
      }));
    }

    if (onDropdownChange === true) {
      formData.value.modules = [];
      moduleDropdown.value = [];
    }

    let operationType;
    let courseModules;
    let actionNumber;

    if (courseResult.status === 'fulfilled') {
      operationType = courseResult.value.data?.data?.operationType;
      courseModules = courseResult.value.data?.data?.modules;
      actionNumber = courseResult.value.data?.data?.actionNumber;
    } else if (coachingData) {
      // Course was deleted after being assigned to this coaching - fall back to the
      // data already embedded in the coaching record instead of failing the whole load.
      operationType = coachingData.nameOfCoaching?.operationType;
      courseModules = coachingData.modules;
      actionNumber = coachingData.nameOfCoaching?.actionNumber;
    } else {
      courseActionNumber.value = '';
      await ErrorToast(courseResult.reason);
      return;
    }

    formData.value.operationType = operationType;
    courseActionNumber.value = actionNumber || '';

    if (operationType === 'modular_integration_coaching' || operationType === 'go_work_mobile') {
      formRules.value = {
        ...formRules.value,
        modules: requiredRule(t),
      };

      moduleDropdown.value = (courseModules || []).map(item => ({
        label: `${item.name}`,
        value: item?.id,
      }));
    } else {
      formData.value.modules = [];
      formRules.value = {
        ...formRules.value,
        modules: '',
      };

      moduleDropdown.value = [];
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

function onAssumptionOfCostsChange(newValue) {
  isCostsAssumedDisabled.value = !newValue.target.checked;
  formData.value.arrivalType = '1';
  formData.value.distance = 0;
}

function addCourseToDropdown(courseData, dropdown) {
  if (courseData?.id) {
    const course = {
      label: courseData.nameOfCoaching,
      value: courseData.id,
    };
    const exists = dropdown.value.some(item => item.value === course.value);
    if (!exists) {
      dropdown.value.push(course);
    }
  }
}

function addClientToDropdown(clientData, dropdown) {
  if (clientData?.id) {
    const client = {
      label: clientData.name,
      value: clientData.id,
    };
    const exists = dropdown.value.some(item => item.value === client.value);
    if (!exists) {
      dropdown.value.push(client);
    }
  }
}

function addCoachToDropdown(coachData, dropdown) {
  if (coachData?.id) {
    const coach = {
      label: `${coachData.firstName} ${coachData.lastName}`,
      value: coachData.id,
    };
    const exists = dropdown.value.some(item => item.value === coach.value);
    if (!exists) {
      dropdown.value.push(coach);
    }
  }
}

async function getPrivateCoachingBillingTypeEnum() {
  billingTypeDropdown.value = getEnums?.value?.privateCoachingBillingTypes || [];
}

// watch(() => formData.value.billingTypeDifferent, (val) => {
//   if (!val) {
//     formData.value.billingType = null
//     formRules.value = {...formRules.value, billingType: ''};
//   } else {
//     formRules.value = {...formRules.value, billingType: requiredRule(t)};
//   }
// })

onMounted(async () => {
  CloseToast();

  // Kick off in parallel with the dropdown loads below - it doesn't depend on them.
  const coachingDataPromise = props.privateCoachingId
      ? privateCoachingService.getPrivateCoaching(props.privateCoachingId)
      : null;

  await Promise.all([
    getCoursePrivateCoachingDropdown(
        courseDropdown,
        'nameOfCoaching',
        'id',
        props.locationId,
    ),
    getUsersForPrivateCoachingDropdown(coach1Dropdown, props.locationId),
    getPrivateCoachingDigitalDocumentsDropdown(
        digitalDocumentsDropdown,
        props.unemployedId
    ),
    getPrivateCoachingBillingTypeEnum(),
  ]);

  coach2Dropdown.value = [...coach1Dropdown.value];
  coach3Dropdown.value = [...coach1Dropdown.value];
  coach4Dropdown.value = [...coach1Dropdown.value];

  if (coachingDataPromise) {
    try {
      const {data} = await coachingDataPromise;
      await applyPrivateCoachingData(data);
    } catch (error) {
      await ErrorToast(error);
    }
  }

  isLoaded.value = true;
});


</script>
<style scoped>

</style>